import {TweenMax} from 'gsap';
import pageInteractionMixin from '../utils/page-interaction-mixin';

//@tmk: I changed offset calculations here - previous one was adding div's top margin and padding
//multiple times
//import offsetTop from '../utils/offset-top';
import getOffset from '../utils/get-offset';

class HashScroller extends pageInteractionMixin() {

    constructor({events, duration = 0.4}) {
		super();
		this.events = events;
		this.duration = duration;
		this.events.on(document, 'history:hashchange', this.onHashChange.bind(this));
    }


	onHashChange(event) {
		const hash = event.detail.hash;
		if (hash !== null) {
			let element = document.querySelector('#' + hash);
			if (!element) {
				element = document.querySelector(this.dataSelector('hash', hash));
			}
			if (element) {
				requestAnimationFrame(() => {
					const position = getOffset(element).top;
					TweenMax.to(window, this.duration, {scrollTo: {y: position, autoKill: false}});
				});
			}
		}
	}

}


export default HashScroller;
